var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogecoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.444 0H29.556C32.3259 0 34.9824 1.10059 36.941 3.05908C38.8997 5.01758 40 7.67432 40 10.4438V29.5562C40.0001 30.9277 39.7301 32.2856 39.2053 33.5527C38.6804 34.8203 37.9111 35.9717 36.9413 36.9414C35.9714 37.9111 34.8201 38.6807 33.5529 39.2051C32.2858 39.73 30.9276 40 29.556 40H10.444C9.07239 40 7.71423 39.73 6.44714 39.2051C5.17993 38.6807 4.02856 37.9111 3.05872 36.9414C2.08887 35.9717 1.31958 34.8203 0.794678 33.5527C0.269898 32.2856 -0.000122029 30.9277 4.13706e-08 29.5562V10.4438C4.13706e-08 7.67432 1.10034 5.01758 3.05896 3.05908C5.01758 1.10059 7.67407 0 10.444 0ZM19.1255 7H11.079V18.6138H8V21.4585H11.0792V33.0718H19.8147C19.8147 33.0718 32.097 34.1011 32.097 20.2539C32.097 7.64111 22.0255 7.02246 19.1255 7ZM19.4456 11.8193C20.7346 11.8193 27.2196 12.3379 27.23 20.3477C27.2397 27.9126 21.2667 28.2393 19.8206 28.252L15.9993 28.2524V21.4585H21.4213V18.6138H15.9993V11.8193H19.4456Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogecoin);
export default __webpack_public_path__ + "static/media/dogecoin.92f9f1e5b96d0c23f74640ca22e21faf.svg";
export { ForwardRef as ReactComponent };